import React, { useState } from 'react'
import ManageLogo from '../../../assets/img/images/manage-asiacommerce.png'
import { Box, Text, Center, TextInput, PasswordInput, Button, Group, Anchor, Grid } from '@mantine/core'
import { useViewportSize } from '@mantine/hooks'
import { validation } from '../../../plugins/validation'
import { login } from '../../../services/auth.js'
import { useDispatch } from 'react-redux'
import { updateDataLogin } from '../../../store/authData.js'
import { notificationSuccess, notificationError } from '../../../component/ui/Notifications'
import http from '../../../plugins/axios.js'
import { encodedText } from '../../../plugins/encrypt.js'
import Cookies from 'universal-cookie'
// import { useNavigate } from 'react-router-dom'
import classes from './Login.module.css'

const defaultVal = {
  email: '',
  password: ''
}

const formValidation = {
  email: {
    isError: false,
    message: ''
  },
  password: {
    isError: false,
    message: ''
  }
}

const Login = () => {
  const cookies = new Cookies()
  // const navigate = useNavigate()
  const dispatch = useDispatch()
  const { width, height } = useViewportSize()
  const [ formData, setFormData ] = useState(defaultVal)
  const [ validationForm, setValidationForm ] = useState(formValidation)
  const [ loading, setLoading ] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setValidationForm(formValidation)
    const payload = {
      username: formData.email,
      password: formData.password,
      client_secret: 'o4plg2OOjl0fr1vXMLae1e87OFvZGKV13inZQEWU',
    }
    const isErrorForm = validation(formData, setValidationForm)
    if (isErrorForm) {
      setLoading(false)
      return
    }
    try {
      const response = await login(payload)
      if (response) {
        notificationSuccess('Login Success', `Welcome Back ${response.user.name}`)
        http.defaults.headers.common['Authorization'] = `Bearer ${response.access_token}`
        const stringValue = JSON.stringify(response)
        const encodedData = encodedText(stringValue)
        cookies.set('manage-session', encodedData, { path: '/' })
        dispatch(updateDataLogin({ 'authorization': response, 'isLogin': true, 'isLoading': false }))
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError('Login Failed', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box>
      <Center maw={width / 1.2} h={height} mx='auto'>
        <Grid justify='center'>
          <Grid.Col span={{ base: 12, md: 8, lg: 8 }}>
            <Box ta='center' mb={20}>
              <img className={classes.imgHeader} src={ManageLogo} alt='Manage Asiacommerce' />
              <Text fz='xs' c='gray.6'>Welcome to Management Dashboard. Only available for AsiaCommerce and AsiaCommerce Network Group employees.</Text>
            </Box>
            <Text fz='xl' fw='bold' mb={20}>Login to your Account</Text>
            <Box>
              <form onSubmit={(e) => {handleSubmit(e)}}>
                <Box>
                  <Box mb='md'>
                    <TextInput
                      name='email'
                      label='Email'
                      placeholder='Please insert your email'
                      error={validationForm.email.isError ? `${validationForm.email.message}` : ''}
                      onChange={handleChange}
                      withAsterisk
                      size='sm'
                    />
                  </Box>
                  <Box mb='md'>
                    <PasswordInput
                      name='password'
                      placeholder='Please insert your password'
                      label='Password'
                      error={validationForm.password.isError ? `${validationForm.password.message}` : ''}
                      onChange={handleChange}
                      withAsterisk
                      size='sm'
                    />
                  </Box>
                </Box>
                <Box mt={30}>
                  <Group grow>
                    <Button radius='md' size='md' loading={loading} type='submit'>Login</Button>
                  </Group>
                </Box>
              </form>
            </Box>
            <Box align="center" mt={30} mb={20}>
              <Anchor component="button" fz={13}>Forgot Password</Anchor>
            </Box>
          </Grid.Col>
        </Grid>
      </Center>  
    </Box>
  )
}

export default Login